



















import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import mailTemplatesRepository from '@/services/default/mailTemplatesRepository';
import Card from '@/components/default/Card.vue';
import MailTemplateDialog from '@/modules/settings/mailtemplates/components/MailTemplateDialog.vue';
import { MailTemplateDto, MailTemplatesClient } from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxDataGrid, DxEditing, DxStateStoring } from 'devextreme-vue/data-grid';

@Component({
  components: {
    MailTemplateDialog,
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class MailTemplatesPage extends Vue {
  loading: boolean = false;
  items: MailTemplateDto[] = [];
  selectedTemplate: MailTemplateDto | null = null;

  public showDialog() {
    this.selectedTemplate = null;
    setTimeout(() => {
      (this.$refs.MailTemplateDialog as MailTemplateDialog).show();
    }, 150);
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.loading = true;
      const client = new MailTemplatesClient(undefined, this.$axios);
      this.items = await client.getAll(undefined);
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  async deleteRow(e: any) {
    try {
      await mailTemplatesRepository.delete(e.data);
      this.loadData();
      notificationService.saved();
    } catch {
      notificationService.failedToSave();
    }
    e.cancel = true;
  }

  get columns(): any[] {
    const self = this;
    return [
      {
        dataField: 'name',
        caption: self.$t('objects.MailTemplate.fields.Name'),
      },
      {
        dataField: 'type',
        caption: self.$t('objects.MailTemplate.fields.Type'),
        alignment: 'left',
        calculateDisplayValue: (value: MailTemplateDto) => {
          return this.$t('objects.MailTemplate.types.' + value.type);
        },
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Edit',
            icon: 'fas fa-edit',
            onClick: (e: any) => {
              self.selectedTemplate = e.row.data;
              setTimeout(() => {
                (self.$refs.MailTemplateDialog as MailTemplateDialog).show();
              }, 150);
            },
          },
          'delete',
        ],
      },
    ];
  }
}
